import React, { useEffect, useState } from 'react';
import ButtonPrimary from '../misc/ButtonPrimary';
import DayAfterTomorrow from './TabTime/DayAfterTomorrow';
import LastDay from './TabTime/LastDay';
import Tomorrow from './TabTime/Tomorrow';

const ModalTimeSend = ({
  handdleCloseModal,
  handdleClickConfirm,
  besok = [
    {
      pagi: [
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '10.00-11.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '10.00-11.00 ',
          price: '10.000',
          choose: false,
        },
      ],
      malam: [
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
      ],
    },
  ],
  lusa = [
    {
      pagi: [
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '10.00-11.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '10.00-11.00 ',
          price: '10.000',
          choose: false,
        },
      ],
      malam: [
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
      ],
    },
  ],
  kamis = [
    {
      pagi: [
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '10.00-11.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '10.00-11.00 ',
          price: '10.000',
          choose: false,
        },
      ],
      malam: [
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
        {
          time: '08.00-09.00 ',
          price: 'gratis',
          choose: false,
        },
        {
          time: '09.00-10.00 ',
          price: '10.000',
          choose: false,
        },
      ],
    },
  ],
  daySending = [
    {
      nameDay: 'besok',
      dateDay: '15 Agustus 2020',
    },
    {
      nameDay: 'lusa',
      dateDay: '16 Agustus 2020',
    },
    {
      nameDay: 'kamis',
      dateDay: '17 Agustus 2020',
    },
  ],
}) => {
  const [filterDay, setFilterDay] = useState('besok');
  // Overflow hidden
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = 'unset');
  }, []);
  console.log('Data ', daySending);
  return (
    <div className="modal fixed w-full min-h-screen top-0 left-0 flex items-center justify-center z-20 overflow-hidden">
      <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50 overflow-hidden"></div>
      <div className="modal-container bg-white w-full md:max-w-xl mx-auto rounded shadow-lg z-50 overflow-y-auto">
        <div className="modal-content items-center p-6 text-left">
          <div className="flex mb-4 text-center justify-center relative">
            <h4 className="self-center">Waktu Pengiriman</h4>
            <button
              className="px-2 absolute right-0"
              onClick={handdleCloseModal}
            >
              X
            </button>
          </div>
          <div className="flex flex-col px-3 py-5 items-start w-full">
            <div className="flex w-full">
              {daySending.map((daySendings, index) => (
                <div
                  className={
                    'border flex flex-col mx-2 px-4 py-3 text-center items-center justify-center rounded-md mb-4 cursor-pointer transition-in-out-300 ' +
                    (filterDay === daySendings.nameDay
                      ? '  border-basic-orange bg-basic-orange text-white'
                      : '  border-gray-300 bg-transparent hover:border-basic-orange hover:bg-basic-orange hover:text-white')
                  }
                  key={index}
                  onClick={() => {
                    setFilterDay(daySendings.nameDay);
                  }}
                >
                  <p className="text-xs capitalize">{daySendings.nameDay}</p>
                  <p className="font-semibold text-sm">{daySendings.dateDay}</p>
                </div>
              ))}
            </div>

            {/* content tab */}

            <div className="flex flex-col w-full">
              {filterDay === 'besok' ? <Tomorrow /> : null}
              {filterDay === 'lusa' ? <DayAfterTomorrow /> : null}
              {filterDay === 'kamis' ? <LastDay /> : null}
            </div>
            {/* End content tab */}
          </div>
          <div className="flex justify-between -mx-2">
            <ButtonPrimary
              handdleClick={handdleClickConfirm}
              text="sm"
              addClass={'w-full mx-2'}
            >
              Konfirmasi
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalTimeSend;
